import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
interface ToastProps {
  message: string | null;
  onDismiss: () => void;
}
export function Toast({
  message,
  onDismiss
}: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(onDismiss, 4000);
    return () => window.clearTimeout(timer);
  }, [message, onDismiss]);
  return <AnimatePresence data-id="element-600" data-mp="1p2d4yd8msv6d">
      {message ? <motion.div role="status" aria-live="polite" initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.18,
      ease: 'easeOut'
    }} className="fixed bottom-5 left-1/2 z-[60] flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-start gap-3 rounded-xl bg-navy-900 px-4 py-3 text-sm text-white shadow-raised" data-id="element-601" data-mp="1l0rsgt00eiwp">
          <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" aria-hidden="true" data-id="element-602" data-mp="11c91c5vg0vfd" />
          <p className="flex-1 font-medium" data-id="element-603" data-mp="iml1z9rygssx">{message}</p>
          <button type="button" onClick={onDismiss} aria-label="Dismiss notification" className="-mr-1 rounded p-1 text-navy-300 hover:bg-white/10 hover:text-white" data-id="element-604" data-mp="il09dpp7bjxp">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-605" data-mp="se7agycwsdrz" />
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}